import classNames from 'classnames';
import React from 'react';
import { Avatar } from '../Avatar';
import { TruncateText } from '../TruncateText';
import { Size } from '../../utils/types/Size';

interface PropTypes {
  name: string;
  type: 'initials' | 'photo' | 'icon';
  size?: Size;
  className?: string;
  avatarClassName?: string;
  disabled?: boolean;
  maxChars?: number;
  textClassName?: string;
  userName?: string;
}

export function AvatarWithName(props: PropTypes) {
  return (
    <div className='d-flex align-items-center'>
      <Avatar
        name={props.name}
        size={props.size ?? 'lg'}
        type={props.type}
        className={props.className}
        avatarClassName={props.avatarClassName}
        disabled={props.disabled}
      />
      <div
        className={classNames(
          'fs-5 fw-semibold text-nowrap',
          props.textClassName,
        )}
      >
        <TruncateText
          ellipsize
          tooltip
          text={props.userName ?? props.name}
          maxChars={props.maxChars}
        />
      </div>
    </div>
  );
}
